import { render } from "./Sconti.vue?vue&type=template&id=6deeae82"
import script from "./Sconti.vue?vue&type=script&lang=js"
export * from "./Sconti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__